import { useTranslation } from 'react-i18next';
import { useBatchViewPrework } from './useBatchView';
import { Table, TablePaginationConfig } from 'antd';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';
import { BatchTableColumns } from '../../prework/ColumnsPrework';
import { FilterBatchesPreWork } from './FilterBatches';

export const BatchViewPreWork = () => {
	const { t } = useTranslation();
	const {
		batchPaging,
		candidateBatchData,
		onBatchPageChange,
		candidateBatchFilter,
		onBatchViewFilterChange,
	} = useBatchViewPrework();
	const { batches, pagination } = candidateBatchData;
	const showTotal = (total: number, range: [number, number]) => (
		<>{`${range[0]}-${range[1]} of ${total} items`}</>
	);
	const tablePaginationConfig: TablePaginationConfig = {
		current: batchPaging.pageNo ?? 1,
		pageSize: batchPaging.pageSize ?? DEFAULT_PAGE_SIZE,
		total: pagination.totalNoOfRecords,
		showTotal,
		onChange: onBatchPageChange,
		showSizeChanger: true,
	};

	const columns = BatchTableColumns();

	if (batches && batches.length && batches.length === 0) {
		return <div>{t('noDataFound')}</div>;
	}

	return (
		<>
			<FilterBatchesPreWork
				value={candidateBatchFilter}
				onFilterChange={onBatchViewFilterChange}
			/>
			<Table
				dataSource={batches}
				columns={columns}
				pagination={tablePaginationConfig}
			/>
		</>
	);
};
